<template>
	<div class="line">
	  <div
		ref="linechart"
		class="linechart"
		@mouseover="autoTimePaused = true"
		@mouseout="autoTimePaused = false"
	  ></div>
	</div>
  </template>
  
<script>
import * as methods from './method.js'
export default {
	name: 'template.scope59',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			title: '基本折线图-带数值-scope59',
			timer: null,
			defaultdata: [
				{ value1: '1月', value2: '80', value3: '系列一' },
				{ value1: '2月', value2: '40' },
				{ value1: '3月', value2: '62' },
				{ value1: '4月', value2: '90' },
				{ value1: '5月', value2: '62' },
				{ value1: '6月', value2: '60' },
				{ value1: '7月', value2: '40' },
			],
			valueMap: [
				{ name: '名称', key: "value1" },
				{ name: '数值', key: "value2" },
				{ name: '图例', key: 'value3' }
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			config: {
			},
			autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
		}
	},
	watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.DrawEcharts()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null
	},
	methods: {
		...methods,
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.linechart);
      let mydata = this.defaultdata.map((item) => {
        return {
          name: item.value1,
          value: item.value2,
        };
      });
      const xAxis = this.defaultdata.map((item) => item.value1);
      const percent = (9 / xAxis.length) * 100;
      let zoom = [
        {
          id: "scope56", // 唯一的id
          type: 'slider',
					moveHandleSize: 0,
					showDetail: false, //关闭：拖拽时候显示详细数值信息。	
          dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
          backgroundColor: "transparent",
          fillerColor:"rgba(0,0,0,.2)",
          borderColor:"transparent",
          start: 0,
          brushSelect: false,
          end: percent
        },
      ];
      var Toption = {
        title: [
          {
            text: "单位:%",
            top: "0",
            left: "0",
            textStyle: {
              color: "#979AA0",
              fontSize: 12,
              width: 80,
              overflow: 'truncate'
            },
          },
        ],
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "5px",
          right: "10px",
          bottom: "0px",
          top: "40px",
          containLabel: true,
        },

        legend: [
          {
            top: "0%",
            right: 50,
            itemHeight: 3, //图例的高度  文字左边那个
            itemWidth: 12,
            icon: "rect",
            textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
            data: [this.defaultdata[0].value3 || ""],
          },
        ],
        xAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
          boundaryGap: false,
          axisLabel: {
            interval: xAxis.length > 12 ? 0 : xAxis.length > 9 ? 1 : 0,
            width: 50,
            overflow: 'truncate', //文字超出宽度截断，默认为...
            
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
              fontSize: "14",
              lineHeight: 16,
            },
            formatter: function (value) {
              return value
            },
          },
          axisPointer: {
            type: "shadow",
          },
          axisLine: {
            lineStyle: {
              // X 轴颜色配置
              color: "#4792e9",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(231,241,251,.2)",
            },
          },
          data: mydata.map((item) => item.name),
        },
        yAxis: {
          type: "value",
          splitNumber: 2,
          axisLabel: {
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为灰白色
            },
            fontSize: 14,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(231,241,251,.2)",
            },
          },
        },
        series: [
          {
            name: this.defaultdata[0].value3 || "",
            type: "line",
            // smooth: true,//线条原画
            // symbol: 'none',//线条点击
            // smooth: 0.5,
            showSymbol: true,
            symbol: "circle",
            symbolSize: 8,
            symbolOffset: [0, "8%"],
            label: {
              show: true,
              position: "top",
              textStyle: {
                //设置文本样式
                color: "#6FF2FA",
              },
              // formatter: '{c} %'
            },
            lineStyle: {
              color: "#04eaea",
              width: 2,
            },
            itemStyle: {
              normal: {
                color: "#05ffff", // 0% 处的颜色
              },
            },
            data: mydata,
          },
        ],
        dataZoom: xAxis.length > 12 ? zoom : [],
      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(() => {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    },
	},
	created() {

	},
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
    this.setData()
		this.DrawEcharts(); //需要刷新的数据
	},
}
</script>

<style scoped>
.line {
  width: 435px;
  height: 240px;
  display: flex;
  position: relative;
  overflow: hidden;
  padding: 10px 0;
}

.linechart {
  width: 100%;
  height: 100%;
}
</style>
